import { UiProvider } from 'component/Context/UiContext'
import { useEffectOnce } from 'hook/useEffectOnce'
import { CatalogStore, createCatalogStore, destroyCatalogStore } from 'page/catalog/store/CatalogStore'
import { createContext, ReactNode, useContext, useMemo } from 'react'
import { DemoCatalogData, DemoCatalogParams } from 'type/demo'

const Context = createContext<CatalogStore | undefined>(undefined)
const Provider = Context.Provider

type Props = {
  children: ReactNode
  data: DemoCatalogData
  params: DemoCatalogParams
}

export function CatalogProvider({ children, data, params }: Props) {
  const store = useMemo(() => createCatalogStore(data, params), [data, params])
  const tsum = !!data.product.tsumDesign

  useEffectOnce(() => {
    return () => destroyCatalogStore()
  })

  return <Provider value={store}>
    <UiProvider tsum={tsum}>
      {children}
    </UiProvider>
  </Provider>
}

export function useDemo(): CatalogStore {
  const context = useContext(Context)
  if (!context) throw new Error('no store')
  return context
}
